module.exports = __webpack_public_path__ + "img/settings.aa57e23f.svg";